import axios from 'axios'

// const API_URL = 'http://localhost:3000'
// const CABLE_URL = 'ws://localhost:3000/cable'

const API_URL = 'https://meta-api.valoran.mx'
const CABLE_URL = 'wss://meta-api.valoran.mx/cable'
// const API_URL = 'https://meta-rwjbb2i66q-uc.a.run.app'
// const CABLE_URL = 'wss://meta-rwjbb2i66q-uc.a.run.app/cable'

const plainAxiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: false,
    headers: {
        'Content-Type': 'application/json',
    }
})

const plainAxiosInstanceAuth = axios.create({
    baseURL: API_URL,
    withCredentials: false,
    headers: {
        'Content-Type': 'application/json',
    }
})

const formAxiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: false,
    headers: {
        'Content-Type': "multipart/form-data",
    }
})

export { plainAxiosInstance, formAxiosInstance, plainAxiosInstanceAuth, CABLE_URL }